import { render } from "./addNotice.vue?vue&type=template&id=675d7b16&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=675d7b16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-675d7b16"

export default script